import {Route} from 'vue-router';
import {BreadcrumbContext} from '@/store/storeStateInterface';

export interface BreadcrumbItem {
    text: string;
    to?: { name: string; params?: Record<string, string> };
    disabled?: boolean;
}

export function buildBreadcrumbs(route: Route, context: BreadcrumbContext): BreadcrumbItem[] {
    const params = route.params as Record<string, string>;
    const name = route.name;

    switch (name) {
        case 'customers_view':
            return [{ text: 'Kundenübersicht', disabled: true }];

        case 'customer_details_view':
            return [
                { text: 'Kundenübersicht', to: { name: 'customers_view' } },
                { text: context.customerName || 'Kunde', disabled: true },
            ];

        case 'station_details_view':
            return [
                { text: 'Kundenübersicht', to: { name: 'customers_view' } },
                {
                    text: context.customerName || 'Kunde',
                    to: { name: 'customer_details_view', params: { customerId: params.customerId } },
                },
                { text: context.stationName || 'Station', disabled: true },
            ];

        case 'machine_details_view':
            return [
                { text: 'Kundenübersicht', to: { name: 'customers_view' } },
                {
                    text: context.customerName || 'Kunde',
                    to: { name: 'customer_details_view', params: { customerId: params.customerId } },
                },
                {
                    text: context.stationName || 'Station',
                    to: {
                        name: 'station_details_view',
                        params: { customerId: params.customerId, stationId: params.stationId },
                    },
                },
                { text: context.machineName || 'Antrieb', disabled: true },
            ];

        case 'map_view':
            return [{ text: 'Interaktive Karte', disabled: true }];

        case 'maintenance_tool_view':
            return [{ text: 'Bestandsaufnahme Tool', disabled: true }];

        case 'actuator_overview_view':
            return [{ text: 'Antriebsübersicht', disabled: true }];

        case 'reports_overview_view':
            return [
                { text: 'Reports', to: { name: 'reports_overview_view' } },
                { text: 'Dashboard / Übersicht', disabled: true },
            ];

        case 'reports_labels_view':
            return [
                { text: 'Reports', to: { name: 'reports_overview_view' } },
                { text: 'Maschinen-/Antriebsansicht', disabled: true },
            ];

        case 'reports_projects_view':
            return [
                { text: 'Reports', to: { name: 'reports_overview_view' } },
                { text: 'Projekte', disabled: true },
            ];

        case 'reports_customers_view':
            return [
                { text: 'Reports', to: { name: 'reports_overview_view' } },
                { text: 'Kunden', disabled: true },
            ];

        case 'reports_technical_view':
            return [
                { text: 'Reports', to: { name: 'reports_overview_view' } },
                { text: 'Technik / Engineering', disabled: true },
            ];

        default:
            return [];
    }
}
